import {RemoteGetServicePoints} from 'data/usecases/private/service-points/remote-get-service-points';
import {GetServicePoints} from 'domain/usecases/private/service-points/get-service-points';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {ServicePointsEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetServicePoints = (): GetServicePoints =>
	new RemoteGetServicePoints(
		makeBFFApiUrl(ServicePointsEndpoints.getServicePoints),
		makeAuthorizeHttpClientDecorator(),
	);
